export const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const APP_ID = (() => {
  const envId = process.env.REACT_APP_INSTANT_APP_ID;
  // Check if it's a valid UUID format (8-4-4-4-12 hex chars)
  if (envId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(envId)) {
    return envId;
  }
  return '1f0f608d-66e6-41da-94b4-e6fd41648781';
})();

export const POSITION_OPTIONS = {
  offense: ['QB', 'RB', 'WR', 'TE', 'OT', 'OG', 'C', 'FB'],
  defense: ['DE', 'DT', 'LB', 'CB', 'S', 'OLB', 'ILB', 'FS', 'SS'],
  specialTeams: ['K', 'P', 'LS', 'KR', 'PR']
};

export const ALL_POSITIONS = [
  ...POSITION_OPTIONS.offense,
  ...POSITION_OPTIONS.defense,
  ...POSITION_OPTIONS.specialTeams
];

export const HERO_IMAGE = 'https://images.unsplash.com/photo-1569211709093-9a21e70d9610?w=1200&q=80';
export const STADIUM_BG = 'https://images.unsplash.com/photo-1708009665157-62f1c641722e?w=1920&q=80';
export const FIELD_BG = 'https://images.unsplash.com/photo-1612607696387-f139f76bdd6c?w=1920&q=80';
